import $ from 'jquery'

export function selectElementContents(el) {
  const body = document.body;
  if (document.createRange && window.getSelection) {
    const range = document.createRange();
    const sel = window.getSelection();
    sel.removeAllRanges();
    try {
      range.selectNodeContents(el);
    } catch (e) {
      range.selectNode(el);
    }
    sel.addRange(range);
  } else if (body.createTextRange) {
    const range = body.createTextRange();
    range.moveToElementText(el);
    range.select();
  }
}

export function copyHtmlToClipboard(targetElement){
  selectElementContents(targetElement);

  document.execCommand("copy");
}

export function copyTextToClipboard(text, attachEl){
  const $temp = $("<textarea>");
  (attachEl || document.body).appendChild($temp[0]);
  $temp.val(text).select();
  document.execCommand("copy");
  $temp.remove();
}